import { Dtos, SuretyAccountId, SuretyBondId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { bondPreviewsQueryKey, bondQueryKey } from "../bond.keys";

export const useCloseBond = (suretyBondId: SuretyBondId, accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.SuretyBond.Close.Request): Promise<void> => {
			await post(`/v2/surety/bonds/${suretyBondId}/close`, data, "none");
		},
		onSuccess: () => {
			queryClient.refetchQueries({ queryKey: bondQueryKey(suretyBondId) });
			queryClient.refetchQueries({ queryKey: bondPreviewsQueryKey() });
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() });
		},
	});

	return { closeBond: mutation.mutate, closeBondLoading: mutation.isPending };
};
